import React, { useMemo, useState } from 'react'

import { QuestionCircleFilled } from '@ant-design/icons'
import { Button, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'

import { useOperatorData } from '@contexts/operator/OperatorDataContext'
import { useIsStandard } from '@contexts/operator/PlanContext'
import { useOperatorNotification } from '@contexts/operator/OperatorNotificationContext'
import InventorySnapshotsList from '@shared/inventory_snapshots/InventorySnapshotsList'
import InventorySnapshotConceptModal from '@shared/inventory_snapshots/InventorySnapshotConceptModal'
import ListPageHeader from '@shared/ListPageHeader'

import { inventorySnapshotService } from '@services/operator/inventorySnapshotService'

export default function OperatorInventorySnapshotsList() {
  const { t } = useTranslation()
  const { merchants, inventoryTypes } = useOperatorData()
  const isStandard = useIsStandard()
  const { addJob } = useOperatorNotification()
  const [conceptModalVisible, setConceptModalVisible] = useState(false)

  const merchantOptions = useMemo(() => {
    return merchants.map(merchant => ({
      label: merchant.name,
      value: merchant.id
    }))
  }, [merchants])

  const inventoryTypeOptions = useMemo(() => {
    return inventoryTypes
      .filter(it => it.name)
      .map(it => ({ label: it.name, value: it.name }))
  }, [inventoryTypes])

  return (
    <div>
      <ListPageHeader
        items={['stocks', 'stocks.history']}
        guideButton={
          <Tooltip title={t('concepts.inventory_snapshots.tooltip')}>
            <Button
              type="text"
              size="small"
              icon={<QuestionCircleFilled style={{ color: '#1890ff' }} />}
              onClick={() => setConceptModalVisible(true)}
              style={{ padding: 0, height: 'auto', minWidth: 'auto' }}
            />
          </Tooltip>
        }
      />
      <InventorySnapshotsList
        service={inventorySnapshotService}
        role="operator"
        merchantOptions={merchantOptions}
        inventoryTypeOptions={inventoryTypeOptions}
        addJob={addJob}
        hideMerchantUI={isStandard}
      />
      <InventorySnapshotConceptModal
        visible={conceptModalVisible}
        onClose={() => setConceptModalVisible(false)}
      />
    </div>
  )
}
